// extracted by mini-css-extract-plugin
export default {"text":"styles_text__HoLPc","startText":"styles_startText__iMwv7"};